import {
	hideLoadingScreen,
	router,
	setPageContent,
	showLoadingScreen,
} from "..";
import { registerFarmcamSim } from "../api/users_{userId}_farmcam-sim";
import { locale } from "../locale";
import { onMobile, scanBarcode } from "../mobile";
import { state } from "../state";
import { objectToQueryString } from "../utils";
import { Bulma } from "../view/bulma";
import { centeredBox } from "../view/components";
import { MaterialDesign } from "../view/material_design";

/**
 * @type {import("navigo").Handler}
 */
function registerFarmcamSimPage(ctx) {
	const scan = () => {
		scanBarcode(
			locale.string({
				enGB: "Scan the IMSI barcode. If the barcode is not recognized, enter the IMSI manually.",
				deDE: "Scannen Sie den IMSI-Strichcode. Wenn der Barcode nicht erkannt wird, geben Sie die IMSI manuell ein.",
				frFR: "Scannez le code-barres IMSI. Si le code-barres n'est pas reconnu, saisissez l'IMSI manuellement.",
				svSE: "Skanna IMSI-streckkoden. Om streckkoden inte känns igen anger du IMSI manuellt.",
			}),
		).then((code) => {
			if (!code) return;
			imsi.setValue(code);
		});
	};

	const imsi = Bulma.input({
		type: "text",
	});

	const name = Bulma.input({
		type: "text",
	});

	setPageContent(
		centeredBox(
			"small",
			Bulma.level(
				Bulma.levelLeft(
					Bulma.levelItem(
						Bulma.title(
							locale.string({
								enGB: "Register FarmCam SIM",
								deDE: "Registrieren FarmCam SIM",
								frFR: "Enregistrez FarmCam SIM",
								svSE: "Registrera FarmCam SIM",
							}),
							"is-4",
						),
					),
				),
				Bulma.levelRight(
					Bulma.levelItem(
						MaterialDesign.icon({
							id: "help",
							onClick: () =>
								window.open(
									locale.string({
										enGB: "https://support.luda.farm/en/support/solutions/folders/140001297",
										deDE: "https://support.luda.farm/de/support/solutions/folders/140001297",
										frFR: "https://support.luda.farm/fr/support/solutions/folders/140001297",
										svSE: "https://support.luda.farm/sv-SE/support/solutions/folders/140001297",
									}),
									"_blank",
								),
						}),
					),
				),
			),
			Bulma.field(
				{},
				Bulma.label("IMSI"),
				Bulma.field(
					{
						styles: onMobile ? ["has-addons"] : undefined,
					},
					Bulma.control(
						{
							styles: ["is-expanded"],
						},
						imsi.element,
					),
					Bulma.control(
						{
							hidden: !onMobile,
						},
						Bulma.button(
							{
								onClick: scan,
							},
							MaterialDesign.icon({
								id: "barcode",
								alignment: "right",
							}),
						),
					),
				),
			),
			Bulma.field(
				{},
				Bulma.label(
					locale.string({
						enGB: "Choose a name for your device",
						deDE: "Wählen Sie einen Namen für Ihr Gerät",
						frFR: "Choisissez un nom pour votre appareil",
						svSE: "Välj ett namn för din enhet",
					}),
				),
				Bulma.control({}, name.element),
			),
			Bulma.field(
				{
					styles: ["is-grouped"],
				},
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: onClickRegister,
							styles: ["is-primary"],
						},
						locale.strings.register,
					),
				),
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: () => router.jump("/devices/register"),
							styles: ["is-primary"],
						},
						locale.strings.back,
					),
				),
			),
		),
	);

	function onClickRegister() {
		showLoadingScreen();
		registerFarmcamSim(imsi.getValue(), name.getValue())
			.then((sim) => {
				state.farmcamSims[sim.Imsi] = sim;
				router.jump("/devices" + objectToQueryString({ id: sim.Imsi }));
			})
			.finally(hideLoadingScreen);
	}
}

export { registerFarmcamSimPage };
